import { render, staticRenderFns } from "./DocCadastro.vue?vue&type=template&id=7f2a8b0d&scoped=true"
import script from "./DocCadastro.vue?vue&type=script&lang=js"
export * from "./DocCadastro.vue?vue&type=script&lang=js"
import style0 from "./DocCadastro.vue?vue&type=style&index=0&id=7f2a8b0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2a8b0d",
  null
  
)

export default component.exports